import { useTranslation } from "react-i18next";
import { Brush2 } from "iconsax-react";
import ThemeSegmentedControl from "./ThemeSegmentedControl";

export default function AppearanceRow() {
  const { t } = useTranslation("Sidebar");

  return (
    <div className="flex items-center gap-2 my-1 radius-sm py-1">
      <div className="flex items-center justify-center">
        <Brush2 size={18} color="currentColor" className="shrink-0 content-base-primary" />
      </div>
      <div className="flex items-center justify-between flex-1">
        <span className="text-label-sm content-base-primary whitespace-nowrap">{t("appearance")}</span>
        <ThemeSegmentedControl />
      </div>
    </div>
  );
}

